import { createContext } from 'utils/react-helpers';

const [LoadGroProvider, useLoadGro] = createContext('LoadGroContext');

export { LoadGroProvider, useLoadGro };
